import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../store/Hooks';
import AlertUtils from '../utils/AlertUtil';
import Utils from '../utils/Utils';
import SupportedLanguages from '../models/enums/SupportedLanguages';
import translator from '../theme/translator.json';

interface ContainerProps {
  show: boolean,
}

const Spinner: React.FC<ContainerProps> = ({
  show,
}) => {
  const dispatch = useAppDispatch();
  const language = useAppSelector((state) => state.user.language) as SupportedLanguages;

  const [open, setOpen] = useState(false);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    try {
      const timer1 = setTimeout(() => {
        setOpen(show);
      }, 10);

      return () => {
        clearTimeout(timer1);
      };
    } catch (e: any) {
      console.error(e);
      AlertUtils.createErrorAlert(Utils.getTranslation(language, translator.errorMessages.general.unknown), dispatch);
    }
  }, [show]);

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 10000 }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Spinner;
